import { AUTH_PROVIDERS, KEYS } from "utils/constants";
import { API_ORIGIN } from "utils/helpers/apiOrigin";

const DEFAULT_DESCRIPTOR = {
  provider: AUTH_PROVIDERS.KAYROS_ID,
  strategy: "credentials",
  paths: {},
};

let cachedDescriptor = null;

const readPersisted = () => {
  try {
    const raw = localStorage.getItem(KEYS.AUTH_PROVIDER);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.provider ? parsed : null;
  } catch (error) {
    return null;
  }
};

const persist = (descriptor) => {
  try {
    localStorage.setItem(KEYS.AUTH_PROVIDER, JSON.stringify(descriptor));
  } catch (error) {
    // Ignore storage failures (private mode, quota, etc.).
  }
};

/**
 * Synchronous access to the active provider descriptor for non-React modules
 * (Apollo links, logout handler). Falls back to the last persisted value, then
 * to the legacy kayros-id provider.
 */
export const getAuthDescriptor = () =>
  cachedDescriptor || readPersisted() || DEFAULT_DESCRIPTOR;

export const getAuthProvider = () => getAuthDescriptor().provider;

/**
 * Fetches the active provider from the core-api and caches it (module variable +
 * localStorage). Called once at boot so synchronous consumers have a value.
 */
export const loadAuthProvider = async () => {
  try {
    const response = await fetch(`${API_ORIGIN}/api/auth/provider`, {
      credentials: "include",
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    cachedDescriptor = {
      provider: data.provider || DEFAULT_DESCRIPTOR.provider,
      strategy: data.strategy || DEFAULT_DESCRIPTOR.strategy,
      paths: data.paths || {},
    };
    persist(cachedDescriptor);
    return cachedDescriptor;
  } catch (error) {
    cachedDescriptor = readPersisted() || DEFAULT_DESCRIPTOR;
    return cachedDescriptor;
  }
};
